/**
 * Microsoft Authentication Library (MSAL) configuration module.
 * Sets up the authentication configuration for Microsoft Entra External ID integration.
 */

import {
  PublicClientApplication,
  BrowserCacheLocation,
} from "@azure/msal-browser";

// Add scopes for Entra External ID
export const loginRequest = {
  scopes: ["openid", "profile", "email", "User.Read"],
};

/**
 * MSAL configuration object that defines the authentication settings.
 * @type {Object}
 * @property {Object} auth - Authentication configuration
 * @property {string} auth.clientId - Entra External ID application client ID
 * @property {string} auth.authority - Entra External ID authority URL
 * @property {string} auth.redirectUri - Application redirect URI after authentication
 * @property {string[]} auth.knownAuthorities - Known authorities for Entra External ID
 */
const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_CLIENT_ID,
    authority: `https://${import.meta.env.VITE_TENANT_NAME}.ciamlogin.com/${
      import.meta.env.VITE_TENANT_ID
    }`,
    redirectUri: window.location.origin,
    knownAuthorities: [`${import.meta.env.VITE_TENANT_NAME}.ciamlogin.com`],
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false, // Recommended for Entra External ID
    loggerOptions: {
      logLevel: "Info",
      piiLoggingEnabled: false,
    },
  },
};

/**
 * MSAL instance configured with the application settings.
 * This instance is used throughout the application for authentication operations.
 * @type {PublicClientApplication}
 */
export const msalInstance = new PublicClientApplication(msalConfig);
